import { loginAPI } from "./api"

export function loginAction(data) {
    return new Promise((resolve, reject) => {
        loginAPI(data).then(res => resolve(res)).catch(err => reject(err))
    })
}
